import { render, staticRenderFns } from "./ShowToMashAdmin.vue?vue&type=template&id=cc8cf916&scoped=true"
import script from "./ShowToMashAdmin.vue?vue&type=script&lang=js"
export * from "./ShowToMashAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc8cf916",
  null
  
)

export default component.exports